import type { ToolRunner } from './base.js';
import type { CheckResult } from '../types/index.js';
import { checkCommand, runCommand, parseSeverity } from './base.js';

interface GitleaksResult {
  Description: string;
  StartLine: number;
  EndLine: number;
  StartColumn: number;
  EndColumn: number;
  Match: string;
  Secret: string;
  File: string;
  Commit: string;
  Entropy: number;
  Author: string;
  Email: string;
  Date: string;
  Message: string;
  Tags: string[];
  RuleID: string;
  Fingerprint: string;
}

export const gitleaksRunner: ToolRunner = {
  name: 'gitleaks',

  async isInstalled(): Promise<boolean> {
    return checkCommand('gitleaks');
  },

  async getVersion(): Promise<string | null> {
    const result = await runCommand('gitleaks', ['version'], process.cwd());
    if (result.exitCode === 0) {
      return result.stdout.trim();
    }
    return null;
  },

  async run(cwd: string, _files?: string[]): Promise<CheckResult[]> {
    const args = ['detect', '--source', cwd, '--report-format', 'json', '--report-path', '-', '--no-git'];

    const result = await runCommand('gitleaks', args, cwd);

    if (result.exitCode === 0) {
      return [];
    }

    try {
      const findings: GitleaksResult[] = JSON.parse(result.stdout || '[]');
      return findings.map((finding) => ({
        ruleId: `secrets.${finding.RuleID}`,
        severity: 'error' as const,
        message: `Secret detected: ${finding.Description}`,
        file: finding.File,
        line: finding.StartLine,
        column: finding.StartColumn,
        endLine: finding.EndLine,
        endColumn: finding.EndColumn,
      }));
    } catch {
      if (result.stdout.includes('no leaks found')) {
        return [];
      }
      return [
        {
          ruleId: 'secrets.no-plaintext',
          severity: 'error',
          message: `Gitleaks error: ${result.stderr || 'Unknown error'}`,
        },
      ];
    }
  },
};
